export enum AccountsListActionType {
  AddAccounts,
  EditList,
}
